export default "__VITE_ASSET__Dhd2bn4T__"